export const MANAGE_ROUTE_PREFIX = 'admin';

export enum MANAGE_PATHS {
  HOME = 'home',
  AVAILABILITY = 'availability',
  CALENDAR = 'calendar',
  TRACKING = 'tracking',
  SETTINGS = 'settings',
  MODULES = 'modules',
  LOCATIONS = 'modules/locations',
  VEHICLES = 'modules/vehicles',
  VEHICLE_GROUPS = 'modules/vehicles/groups',
  VEHICLE_CATEGORIES = 'modules/vehicles/categories',
  SUPPLIERS = 'modules/suppliers',
  CUSTOMERS = 'modules/customers',
  AGENTS = 'modules/agents',
  AGENT_CATEGORIES = 'modules/agents/categories',
  TAGS = 'modules/tags',
  RENTER_ACCOUNTS = 'modules/renter-accounts',
  RENTALS = 'modules/rentals',
  MAINTENANCES = 'modules/maintenances',
  RESERVATIONS = 'modules/reservations',
  ROAD_TAXES = 'modules/road-taxes',
  ROAD_WORTHY_CHECKS = 'modules/road-worthy-checks',
  DAMAGES = 'modules/damages',
  INSURANCES = 'modules/insurances',
  TRANSACTIONS = 'modules/transactions',
  NOT_FOUND = 'not-found',
  LOGIN = 'login',
}
